module.exports = __webpack_public_path__ + "img/default_icon.add24bf6.png";